<template>
  <div
    class="fixed inset-0 z-[1200] flex items-center justify-center bg-black/60"
    @mousedown.self="emit('close')"
  >
    <div
      class="flex max-h-[90vh] w-full flex-col overflow-hidden rounded-xl border border-zinc-700 bg-zinc-900 text-zinc-100 shadow-2xl"
      :class="wide ? 'max-w-3xl' : 'max-w-lg'"
    >
      <div
        class="flex items-center justify-between border-b border-zinc-700 px-5 py-3"
      >
        <h3 class="text-base font-semibold">{{ title }}</h3>
        <button
          class="rounded p-1 text-zinc-400 hover:bg-zinc-700 hover:text-zinc-100"
          @click="emit('close')"
        >
          ✕
        </button>
      </div>
      <div class="overflow-y-auto px-5 py-4">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="flex justify-end gap-2 border-t border-zinc-700 px-5 py-3"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { title, wide = false } = defineProps<{
  title: string
  wide?: boolean
}>()

const emit = defineEmits<{ close: [] }>()
</script>
